/**
 * サイズオーダー商品の 形×カラー バリエーション選択（暫定 / #93）
 *
 * `size-order-variant-selector` スニペットが出力する選択UIと variant マップを読み、
 * - 選択された 形×カラー から variant を解決
 * - cart/add フォームの hidden `input[name="id"]` を更新（product.js は formData.get("id") を参照）
 * - メインの追加ボタンの data-variant-id を更新（addon ボタンは除外）
 * - `variant:change` を form に dispatch し、Prestige の product-gallery 画像切替を再利用
 *
 * 本体 theme.js / product.js は変更しない。商品に 形/カラー variant が無い既存商品では
 * スニペット自体が出力されないため、本スクリプトは何もしない。
 */
(function () {
  "use strict";

  function init(container) {
    // 多重 boot（quick-buy 等で同一 container が再処理される場合）を防ぐ
    if (container.dataset.soInit) return;
    container.dataset.soInit = "1";

    const dataEl = container.querySelector(".js-so-variant-data");
    if (!dataEl) return;

    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    const shapeRadios = container.querySelectorAll(".js-so-shape");
    const colorRadios = container.querySelectorAll(".js-so-color");
    const hasShape = shapeRadios.length > 0;
    const hasColor = colorRadios.length > 0;
    let previousVariant = null;
    let suppressResolve = false;

    function findVariant(shapeVal, colorVal) {
      return variants.find(function (v) {
        if (hasShape && v.shape !== shapeVal) return false;
        if (hasColor && v.color !== colorVal) return false;
        return true;
      });
    }

    function applyVariant(variant) {
      // 1) cart/add フォームの variant id
      document
        .querySelectorAll('form[action*="/cart/add"] input[name="id"]')
        .forEach(function (input) {
          input.value = variant.id;
          input.disabled = false;
        });

      // 2) メインの追加ボタン（addon ボタンは除外）
      document
        .querySelectorAll('button[onclick*="addToCart"][data-variant-id]')
        .forEach(function (btn) {
          if (btn.closest("[data-addon-ui-id]")) return;
          btn.dataset.variantId = String(variant.id);
        });

      // 3) 画像切替（Prestige product-gallery が variant:change を購読）
      dispatchVariantChange(variant);
      previousVariant = variant;
    }

    function mediaOf(variant) {
      if (variant && variant.media_id != null) {
        return { id: variant.media_id, position: variant.media_position };
      }
      return null;
    }

    function dispatchVariantChange(variant) {
      const detail = {
        variant: { id: variant.id, featured_media: mediaOf(variant) },
        previousVariant: previousVariant
          ? { id: previousVariant.id, featured_media: mediaOf(previousVariant) }
          : null,
      };
      document
        .querySelectorAll('form[action*="/cart/add"]')
        .forEach(function (form) {
          form.dispatchEvent(
            new CustomEvent("variant:change", { bubbles: true, detail: detail })
          );
        });
    }

    function resolve() {
      if (suppressResolve) return;
      const shapeEl = container.querySelector(".js-so-shape:checked");
      const colorEl = container.querySelector(".js-so-color:checked");
      if (hasShape && !shapeEl) return;
      if (hasColor && !colorEl) return;
      const variant = findVariant(
        shapeEl ? shapeEl.dataset.soShape : null,
        colorEl ? colorEl.dataset.soColor : null
      );
      if (variant) applyVariant(variant);
    }

    container
      .querySelectorAll(".js-so-shape, .js-so-color")
      .forEach(function (r) {
        r.addEventListener("change", resolve);
      });

    // 初期選択: 最初の購入可能な variant（受注生産=継続販売のため基本 available）
    const firstAvailable =
      variants.find(function (v) {
        return v.available;
      }) || variants[0];

    if (firstAvailable) {
      // preselect の change は inputChanged（タイトル状態更新）目的。
      // resolve は抑止し、選択確定後に1回だけ applyVariant を走らせる。
      suppressResolve = true;
      preselect(shapeRadios, "soShape", firstAvailable.shape, hasShape);
      preselect(colorRadios, "soColor", firstAvailable.color, hasColor);
      suppressResolve = false;
      resolve();
    }

    function preselect(radios, key, value, enabled) {
      if (!enabled) return;
      radios.forEach(function (r) {
        if (r.dataset[key] === value && !r.checked) {
          r.checked = true;
          // 既存ハンドラ（inputChanged 等）にも通知してタイトル状態を更新
          r.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll(".js-size-order-variant").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
